document.addEventListener('DOMContentLoaded', function () {
  const bundleAddToCart = document.querySelector('.js-pdp-custom-bundle-atc')
  const bundleItems = document.querySelectorAll('.js-pdp-custom-bundle-item')
  const bundleQuantity = document.querySelector(
    '.js-pdp-custom-bundle-quantity',
  )
  const sellingPlanSelect = document.querySelector(
    '.js-pdp-custom-bundle-atc-select',
  )

  if (
    !bundleAddToCart ||
    !bundleItems.length ||
    !bundleQuantity ||
    !sellingPlanSelect
  )
    return

  if (window.__pdpCustomBundleBound) {
    return
  }
  window.__pdpCustomBundleBound = true

  // Modal functionality
  const modal = document.querySelector('.js-pdp-custom-bundle-modal')
  const learnMoreButton = document.querySelector(
    '.js-pdp-custom-bundle-learn-more',
  )

  // Move modal to body to escape any stacking context issues
  if (modal) {
    document.body.appendChild(modal)
  }

  const modalCloseButtons = document.querySelectorAll(
    '.js-pdp-custom-bundle-modal-close',
  )

  let lastFocusedElement = null

  function getFocusableElements() {
    if (!modal) return []
    return modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    )
  }

  function handleTabKey(e) {
    const focusableElements = getFocusableElements()
    if (focusableElements.length === 0) return

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault()
        lastElement.focus()
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault()
        firstElement.focus()
      }
    }
  }

  function openModal() {
    if (!modal) return
    lastFocusedElement = document.activeElement
    modal.classList.add('is-open')
    modal.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'

    modal.addEventListener('keydown', trapFocus)

    setTimeout(function () {
      var focusableElements = getFocusableElements()
      if (focusableElements.length > 0) {
        focusableElements[0].focus()
      }
    }, 100)
  }

  function closeModal() {
    if (!modal) return
    modal.classList.remove('is-open')
    modal.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''

    modal.removeEventListener('keydown', trapFocus)

    if (lastFocusedElement) {
      lastFocusedElement.focus()
    }
  }

  function trapFocus(e) {
    if (e.key === 'Tab') {
      handleTabKey(e)
    }
  }

  if (learnMoreButton) {
    learnMoreButton.addEventListener('click', function (e) {
      e.preventDefault()
      openModal()
    })
  }

  modalCloseButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closeModal()
    })
  })

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal()
    }
  })

  bundleAddToCart.addEventListener('click', async function () {
    // Add loading state to bundle button and sticky button
    bundleAddToCart.classList.add('working')
    const stickyButton = document.querySelector(
      'sticky-add-to-cart button[data-js-atc]',
    )
    if (stickyButton) {
      stickyButton.classList.add('working')
    }

    const bundleArray = []

    const bundleProductData = {
      productId: '7795024363590',
      variantId: 42525769433158,
      handle: 'customizable-bundle-test-v1',
    }
    const sellingPlanValue = sellingPlanSelect.value

    const COLLECTION_ID = '289448460358'

    bundleItems.forEach((item) => {
      const sellingPlansData = item.getAttribute('data-selling-plans')
      if (!sellingPlansData) {
        console.error('No selling plans data found for item:', item)
        return
      }

      const sellingPlan = JSON.parse(sellingPlansData).filter((plan) => {
        return plan.name.toLowerCase() === sellingPlanValue.toLowerCase()
      })

      if (
        !sellingPlan.length ||
        !sellingPlan[0].selling_plans ||
        !sellingPlan[0].selling_plans.length
      ) {
        console.error(
          'No matching selling plan found for:',
          sellingPlanValue,
          item,
        )
        return
      }

      const newItem = {
        collectionId: COLLECTION_ID,
        externalProductId: item.getAttribute('data-bundle-product-id'),
        externalVariantId: item.getAttribute('data-variant-id'),
        sellingPlan: Number(sellingPlan[0].selling_plans[0].id),
        quantity: Number(bundleQuantity.value),
      }

      bundleArray.push(newItem)
    })

    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: bundleArray,
    }

    try {
      const cartItems = await recharge.bundle.getDynamicBundleItems(
        bundle,
        bundleProductData.handle,
      )
      const pdpTitle = document.querySelector(
        'h1.product__title.heading-size--page-title',
      )
      const cartItemsWithProperties = cartItems.map((item) => ({
        ...item,
        properties: {
          ...item.properties,
          _bundle_source: 'premade-bundle-pdp',
          _pdp_title: pdpTitle ? pdpTitle.textContent.trim() : '',
        },
      }))
      const cartData = { items: cartItemsWithProperties }

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData),
      })

      const result = await response.json()

      // Remove loading state after completion
      bundleAddToCart.classList.remove('working')
      if (stickyButton) {
        stickyButton.classList.remove('working')
      }

      // Trigger cart update if needed
      if (typeof window.handleAddToCart === 'function') {
        // Let the existing cart handler manage cart updates
        window.dispatchEvent(new CustomEvent('cart:updated'))
      } else {
        // Fallback: refresh cart section
        fetch('?section_id=helper-cart')
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser().parseFromString(
              text,
              'text/html',
            )
            const cartSection = document.getElementById('helper-cart')
            if (cartSection) {
              cartSection.innerHTML =
                sectionInnerHTML.getElementById('helper-cart').innerHTML
            }
          })
          .catch((error) => console.error('Error updating cart:', error))
      }
    } catch (error) {
      console.error('Error:', error)
      // Remove loading state even on error
      bundleAddToCart.classList.remove('working')
      if (stickyButton) {
        stickyButton.classList.remove('working')
      }
    }
  })
})
